import ArrowSVG from '@public/icons/arrow.svg';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Document } from '@/entities/document';
import { useLocale } from '@/shared/hooks/use-locale';
import { tp } from '@/shared/lib/typograf';
import DownloadButton from '../../shared/DownloadButton';

export interface ServicesContentProps {
    title: string;
    content: string;
    pdfFile?: Document | null;
    /** Внешняя ссылка вместо документа: если заполнена, показываем её, а не кнопку скачивания */
    link?: string;
    linkText?: string;
}

const SECTION_ID = 'services-content';

type Props = React.HTMLAttributes<HTMLElement> & {
    servicesContent: ServicesContentProps;
};

export default function ServicesContent({ servicesContent, ...props }: Props) {
    const locale = useLocale();
    const tpTitle = useMemo(() => tp(servicesContent.title || '', locale), [servicesContent.title, locale]);
    const tpContent = useMemo(() => tp(servicesContent.content || '', locale), [servicesContent.content, locale]);
    const pdfDocument = servicesContent.pdfFile?.src ?? '';

    return (
        tpContent && (
            <div {...props} className={classNames('wrapper', props.className)} id={props.id ?? SECTION_ID}>
                <div className="services-content">
                    <div className="services-content__title h4">{tpTitle}</div>
                    <div className="services-content__content">
                        <div
                            className="services-content__content-inner text-m"
                            dangerouslySetInnerHTML={{ __html: tpContent }}
                        />
                        {servicesContent.link && (
                            <div className="download-button">
                                <a
                                    className="download-button__wrapper"
                                    href={servicesContent.link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="download-button__left text-xs">
                                        {tp(servicesContent.linkText || 'Расписание шаттлов', locale)}
                                    </span>
                                    <ArrowSVG className="download-svg" />
                                </a>
                            </div>
                        )}
                        {!servicesContent.link && pdfDocument && servicesContent.pdfFile && (
                            <DownloadButton
                                downloadButtonProps={{
                                    src: servicesContent.pdfFile.src,
                                    title: servicesContent.pdfFile.title || '',
                                    alt: servicesContent.pdfFile.alt ?? '',
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    );
}
